import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { Button, ChatPanel } from 'chatbot/components';
import { Size } from 'theme/enums';

interface IProps {
  quoteId: number;
}

export const ChatbotCreateBomButton = ({ quoteId }: IProps) => {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const onComplete = () => {
    setIsChatbotOpen(false);
    queryClient.invalidateQueries('customerQuoteParts');
  };

  return (
    <>
      <Button onClick={() => setIsChatbotOpen(true)}>{t('buttonLabelUseAIToCreateBom')}</Button>

      <ChatPanel
        quoteId={quoteId}
        title={t('titleTryToCreateBom')}
        isOpen={isChatbotOpen}
        onClose={() => setIsChatbotOpen(false)}
        onComplete={onComplete}
        size={Size.LG}
      />
    </>
  );
};
